/** @file dock-manager/PatternGhost.jsx — dashed occurrence for an unfulfilled pattern. */
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { fmtRange } from "./formatters";

export default function PatternGhost({ ghost, windowStart, windowEnd, pxPerHour }) {
  const { start, end, pattern } = ghost;
  const visStart = start < windowStart ? windowStart : start;
  const visEnd = end > windowEnd ? windowEnd : end;
  if (visEnd <= visStart) return null;
  const leftHours = (visStart - windowStart) / 3600 / 1000;
  const widthHours = (visEnd - visStart) / 3600 / 1000;
  const held = pattern.is_active === false;
  return (
    <div
      className={`absolute top-2 bottom-2 rounded-md border border-dashed pointer-events-none ${
        held ? "border-slate-400 bg-slate-200/40" : "border-blue-300 bg-blue-100/40"
      }`}
      style={{
        left: leftHours * pxPerHour,
        width: widthHours * pxPerHour - 2,
        backgroundImage:
          "repeating-linear-gradient(135deg, transparent 0 6px, rgba(100,116,139,0.18) 6px 8px)",
      }}
      title={`${held ? "Held" : "Active"} recurring · ${
        pattern.booking_template?.sender_name || pattern.booking_template?.vehicle_type || "Pattern"
      }`}
      data-testid={`pattern-ghost-${ghost.id}`}
    >
      <div className="text-[10px] text-slate-600 truncate px-1.5 py-0.5 italic">
        {held ? "Held · " : "Recurring · "}
        {pattern.booking_template?.sender_name ||
          pattern.booking_template?.vehicle_type ||
          "preview"}
      </div>
    </div>
  );
}

